import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "tabular-row main-entry"
}
const _hoisted_3 = { class: "main-entry-code" }
const _hoisted_4 = {
  key: 1,
  class: "tabular-row main-entry-instructions"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "tabular-row regular"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 3,
  class: "tabular-row main-entry-selectable"
}
const _hoisted_9 = { class: "main-entry-selectable-content" }
const _hoisted_10 = {
  key: 0,
  class: "main-entry-selectable-cc cc"
}
const _hoisted_11 = {
  key: 1,
  class: "main-entry-selectable-cc mcc"
}
const _hoisted_12 = {
  key: 2,
  class: "main-entry-selectable-cc hcc"
}
const _hoisted_13 = { class: "add-code-chip" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 4,
  class: "instructional-note-excludes"
}
const _hoisted_16 = { class: "exclude-header" }
const _hoisted_17 = { class: "exclude-content" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 5,
  class: "instructional-note-excludes"
}
const _hoisted_20 = { class: "exclude-header include-header" }
const _hoisted_21 = { class: "exclude-content" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 6,
  class: "instructional-note"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, "Note:", -1)
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 7,
  class: "section-title"
}
const _hoisted_27 = { key: 8 }

import {onUpdated, ref, watch} from 'vue';
import {useSearchStore} from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';
import {Services} from 'src/services/service-manager';
import {BookViewRecord, SearchService} from 'src/services/search-service';
import { isEmpty } from 'src/common/arrayUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosisTabularList',
  setup(__props) {


const minDataSequence = ref<number>();
const maxDataSequence = ref<number>();
const lastTimeStamp = ref<number>();
const viewType = ref<string>();
const scrollViewTop = ref<boolean>();
const {searchResultDetails, initialItemRecord} = storeToRefs(useSearchStore());
const trucodeSearchService = Services.service(SearchService);
const grouperStore = useGrouperStore();

const tabularDiagnosisData = ref<Array<BookViewRecord>>([]);
const minPreviousSequence = ref<number>();
const maxPreviousSequence = ref<number>();

// This is entry point where click from the left search view performed
watch(searchResultDetails, (newSearchResults) => parseNewResponse(newSearchResults));

function parseNewResponse(newSearchResults: BookViewRecord[] | undefined) {
  tabularDiagnosisData.value = [];

  if (isEmpty(newSearchResults)) {
    return;
  }

  viewType.value = newSearchResults?.[0].data_book;
  // Refresh all data
  minDataSequence.value = initialItemRecord.value?.data_sequence;
  maxDataSequence.value = initialItemRecord.value?.data_sequence;
  scrollViewTop.value = false;
  minPreviousSequence.value = undefined;
  maxPreviousSequence.value = undefined;

  if (viewType.value == 'ICD10CM_DX_TABULAR' && newSearchResults && newSearchResults.length > 0) {
    parseResponseDiagnosisTabular(newSearchResults, true);
  }
}

// We should let data pass to vue and render, then perform scroll
onUpdated(() => { scrollToHighlight(); })

function scrollToHighlight() {
  if (viewType.value !== 'ICD10CM_DX_TABULAR' || !initialItemRecord.value) return;
  if (minPreviousSequence.value) {
    // We need to scroll to previous top or bottom element otherwise view will jump
    const matchingElement = document.getElementById(scrollViewTop.value ? minPreviousSequence.value : maxPreviousSequence.value);
    matchingElement?.scrollIntoView();
  } else {
    const matchingElement = document.getElementById(initialItemRecord.value?.data_sequence);
    matchingElement?.scrollIntoView();
  }
}

function parseResponseDiagnosisTabular(records: BookViewRecord[], bottom: boolean) {
  if (tabularDiagnosisData.value.length > 0) {
    minPreviousSequence.value = tabularDiagnosisData.value[0].data_sequence;
    maxPreviousSequence.value = tabularDiagnosisData.value[tabularDiagnosisData.value.length - 1].data_sequence;
  }
  if (bottom) {
    tabularDiagnosisData.value.push(...records);
  } else {
    tabularDiagnosisData.value.unshift(...records);
  }
}

function onScrollDiagnosisTabular(event) {
  const el = event.target;
  // Second part is hack for multiple scroll events to pass only one
  if ((el.scrollHeight - el.scrollTop - el.clientHeight < 5) && (!lastTimeStamp.value || (event.timeStamp - lastTimeStamp.value) > 50)) {
    lastTimeStamp.value = event.timeStamp;
    maxDataSequence.value = maxDataSequence.value + 50;
    trucodeSearchService.getCodebooksDetails(viewType.value, maxDataSequence.value, useGrouperStore().patientEffectiveDate).then((resultDetails) => {
      parseResponseDiagnosisTabular(resultDetails, true);
      scrollViewTop.value = false;
    });
  } else if (el.scrollTop === 0) {
    minDataSequence.value = minDataSequence.value - 50;
    trucodeSearchService.getCodebooksDetails(viewType.value, minDataSequence.value, useGrouperStore().patientEffectiveDate).then((resultDetails) => {
      parseResponseDiagnosisTabular(resultDetails, false);
      scrollViewTop.value = true;
    });
  }
}

function getExcludeText(content: string) {
  if (content.startsWith('Excludes') || content.startsWith('Includes')) {
    // Strip off ExcludesN: or Includes: in content itself, we add this styled manually
    return content.substring(content.indexOf(':') + 1);
  } else {
    return content;
  }
}

function addDiagnosisCode(code: string, description: string) {
  grouperStore.addDiagnosisCode(code, description, undefined, true);
}


return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "iodine-scrollable-y browse-search",
    onScroll: onScrollDiagnosisTabular
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabularDiagnosisData.value, (record, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", {
          class: _normalizeClass(`diagnosis-tab-row shift-${record.record.level}`),
          id: `${record.data_sequence}`
        }, [
          (record.record.type === 'mainentry' && record.record.codes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, _toDisplayString(record.record.content), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(record.record.codes[0].startcode), 1)
              ]))
            : (record.record.type === 'mainentry')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data.segments, (segment, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("div", {
                        innerHTML: segment.content
                      }, null, 8, _hoisted_5)
                    ]))
                  }), 128))
                ]))
              : (record.record.type === 'regular')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.regular_note_data.segments, (segment, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", {
                          innerHTML: segment.content
                        }, null, 8, _hoisted_7)
                      ]))
                    }), 128))
                  ]))
                : (record.record.type === 'mainentryselectable')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (record.record.subtypes[0] && record.record.subtypes[0].name === 'complication-comorbid')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "CC"))
                          : _createCommentVNode("", true),
                        (record.record.subtypes[0] && record.record.subtypes[0].name === 'major-complication-comorbid')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "MCC"))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(record.record.content) + " ", 1),
                        (record.record.hccs)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "HCC"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "add-code-button",
                          onClick: ($event: any) => (addDiagnosisCode(record.record.codes[0].startcode, record.record.content))
                        }, [
                          _createVNode(_component_q_tooltip, {
                            anchor: "bottom middle",
                            self: "center middle"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Add Code ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_icon, {
                            class: "code-icon",
                            name: "fa-light fa-circle-plus",
                            size: "14px"
                          }),
                          _createTextVNode(_toDisplayString(record.record.codes[0].startcode), 1)
                        ], 8, _hoisted_14)
                      ])
                    ]))
                  : (record.record.type === 'instructionalnote' && record.record.instructional_note_data &&
            record.record.instructional_note_data.type.startsWith('excludes'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(record.record.instructional_note_data.type) + ":", 1),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data.segments, (segment, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("div", {
                                innerHTML: getExcludeText(segment.content)
                              }, null, 8, _hoisted_18)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (record.record.type === 'instructionalnote' && record.record.instructional_note_data &&
            record.record.instructional_note_data.type.startsWith('includes'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(record.record.instructional_note_data.type) + ":", 1),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data.segments, (segment, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("div", {
                                  innerHTML: getExcludeText(segment.content)
                                }, null, 8, _hoisted_22)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (record.record.type === 'instructionalnote')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _hoisted_24,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data.segments, (segment, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "instructional-note-segment",
                                key: index
                              }, [
                                _createElementVNode("div", {
                                  innerHTML: segment.content
                                }, null, 8, _hoisted_25)
                              ]))
                            }), 128))
                          ]))
                        : (record.record.type === 'sectiontitle')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", null, _toDisplayString(record.record.content) + " (" + _toDisplayString(record.record.codes[0].startcode) + " - " + _toDisplayString(record.record.codes[1]?.startcode) + ")", 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("div", null, "implement me " + _toDisplayString(record.record.type), 1)
                            ]))
        ], 10, _hoisted_1)
      ]))
    }), 128))
  ], 32))
}
}

})